/* pawlab-bilingual-bust-1789954000 gifts-for-pets */
/* pawlab-bilingual-fix v7.5-launch-promo — sitewide free-shipping bar until manually stopped */
(function () {
  try {
    // Domain cutover: vitalpawhk.com -> www.pawlabandstudio.com (client-side safety net)
    (function domainCutover(){
      try {
        var pairs = [
          ['https://www.instagram.com/vitalpawhk/', 'https://www.instagram.com/pawlabandstudio/'],
          ['https://instagram.com/vitalpawhk/', 'https://www.instagram.com/pawlabandstudio/'],
          ['hello@vitalpawhk.com', 'hello@pawlabandstudio.com'],
          ['info@vitalpawhk.com', 'info@pawlabandstudio.com'],
          ['founder@vitalpawhk.com', 'founder@pawlabandstudio.com'],
          ['https://vitalpawhk.com', 'https://www.pawlabandstudio.com'],
          ['http://vitalpawhk.com', 'https://www.pawlabandstudio.com'],
          ['//vitalpawhk.com', '//www.pawlabandstudio.com']
        ];
        function fixAttr(el, attr){
          var v = el.getAttribute(attr);
          if (!v) return;
          var n = v;
          for (var i=0;i<pairs.length;i++){ n = n.split(pairs[i][0]).join(pairs[i][1]); }
          // bare host in attrs
          n = n.replace(/vitalpawhk\.com/g, 'www.pawlabandstudio.com');
          if (n !== v) el.setAttribute(attr, n);
        }
        function fixText(node){
          var v = node.nodeValue;
          if (!v || v.indexOf('vitalpawhk') === -1) return;
          var n = v;
          for (var i=0;i<pairs.length;i++){ n = n.split(pairs[i][0]).join(pairs[i][1]); }
          n = n.replace(/vitalpawhk\.com/g, 'www.pawlabandstudio.com');
          if (n !== v) node.nodeValue = n;
        }
        var root = document.documentElement;
        root.querySelectorAll('a[href], link[href], img[src], script[src], form[action]').forEach(function(el){
          fixAttr(el,'href'); fixAttr(el,'src'); fixAttr(el,'action');
        });
        var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var node; while ((node = walk.nextNode())) fixText(node);
      } catch (e) {}
    })();

    // Ensure site type scale loads even when translated header liquid is stale
    (function ensureTypeCss() {
      try {
        if (document.querySelector('link[href*="pawlab-type.css"]')) return;
        var existing = document.querySelector(
          'link[href*="pawlab-pdp.css"], link[href*="pawlab-plp.css"], link[href*="pawlab-cards.css"]'
        );
        var href = null;
        if (existing && existing.href) {
          href = existing.href.replace(/pawlab-(pdp|plp|cards)\.css[^?]*/, "pawlab-type.css");
        } else {
          var scripts = document.querySelectorAll('script[src*="pawlab-bilingual-fix.js"]');
          if (scripts.length && scripts[0].src) {
            href = scripts[0].src.replace(/pawlab-bilingual-fix\.js[^?]*/, "pawlab-type.css");
          }
        }
        if (!href) return;
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
      } catch (e) {}
    })();

    // Keep mobile filters drawer usable (do not hide #filters-drawer with vertical sidebar CSS)
        (function ensureFiltersDrawer() {
      try {
        if (document.getElementById("pawlab-plp-filters-fix-v1-js")) return;
        var css = "/* pawlab-plp-gap-fix-v1 */@media screen and (max-width:749px){  .facets.facets--horizontal,  .facets.facets--horizontal.facets-controls-wrapper{    display:flex!important;height:auto!important;max-height:none!important;min-height:0!important;    width:100%!important;max-width:100%!important;top:auto!important;bottom:auto!important;inset:auto!important;    box-shadow:none!important;justify-content:flex-start!important;align-items:center!important;    border-bottom:0!important;margin:0 0 .2rem!important;padding-block:.1rem .15rem!important;    padding-inline:0!important;overflow:visible!important;position:relative!important  }  .facets-controls-wrapper .products-count-wrapper,  .facets-controls-wrapper .products-count-wrapper span{margin:0!important;line-height:1.3!important}}@media screen and (max-width:749px){.collection-wrapper{position:relative!important;display:flex!important;flex-direction:column!important;gap:0!important;row-gap:0!important;min-height:0!important}.collection-wrapper > div.facets-block-wrapper--vertical,.main-collection-grid > div.facets-block-wrapper--vertical,div.facets-block-wrapper.facets-block-wrapper--vertical:not(dialog-component):not(#filters-drawer){display:none!important;height:0!important;width:0!important;overflow:hidden!important;margin:0!important;padding:0!important;order:98!important}#filters-drawer,dialog-component#filters-drawer{position:absolute!important;width:0!important;height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;flex:0 0 0!important;order:99!important;pointer-events:none!important}#filters-drawer dialog[open],dialog-component#filters-drawer dialog[open]{pointer-events:auto!important}.facets.facets--horizontal.facets-controls-wrapper > .sorting-filter,.facets.facets--horizontal.facets-controls-wrapper > sorting-filter-component,.facets.facets--horizontal.facets-controls-wrapper [data-testid=\"sorting-filter-component-desktop\"]{display:none!important}.facets.facets--horizontal.facets-controls-wrapper{padding-block:.15rem .2rem!important;margin-bottom:.25rem!important;border-bottom:0!important;min-height:0!important}.facets-toggle{display:grid!important;grid-template-columns:1fr 1fr!important;height:44px!important;min-height:44px!important;margin:0 0 .55rem!important;padding:0!important;border:1px solid #e5e0d8!important;border-radius:8px!important;background:#fff!important;overflow:hidden!important}.facets-toggle__wrapper{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important;margin:0!important;border-inline-end:1px solid #e5e0d8!important}.facets-toggle__button{width:100%!important;height:100%!important;justify-content:center!important;gap:.4rem!important;font-size:.875rem!important;font-weight:550!important;color:#1a1a1a!important}.facets-mobile-wrapper,.facets-mobile-wrapper .sorting-filter,.facets-mobile-wrapper sorting-filter-component,.facets-mobile-wrapper .sorting-filter__container{display:flex!important;width:100%!important;height:100%!important;align-items:center!important;justify-content:center!important;margin:0!important;padding:0!important}.facets-mobile-wrapper .facets__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important}.facets-mobile-wrapper .sorting-filter__select-wrapper{position:relative!important;width:100%!important;height:100%!important;display:flex!important;align-items:center!important;justify-content:center!important}.facets-mobile-wrapper .sorting-filter__select{width:100%!important;height:100%!important;border:0!important;background:transparent!important;box-shadow:none!important;font-size:.875rem!important;font-weight:550!important;color:#1a1a1a!important;text-align:center!important;text-align-last:center;padding-inline:.5rem 1.25rem!important;appearance:none!important;-webkit-appearance:none!important}.facets-mobile-wrapper .sorting-filter__select-wrapper::after{content:\"\";position:absolute;right:.65rem;top:50%;width:.45rem;height:.45rem;border-inline-end:1.5px solid #1a1a1a;border-block-end:1.5px solid #1a1a1a;transform:translateY(-65%) rotate(45deg);pointer-events:none}.collection-wrapper > .facets.facets--horizontal.facets-controls-wrapper{order:1!important}.collection-wrapper > .facets-toggle{order:2!important}.collection-wrapper > results-list,.collection-wrapper .product-grid-container,#ResultsList{order:3!important;margin-block-start:0!important;padding-block-start:0!important}.shopify-section:has(.pawlab-plp-crumb){padding-block:.2rem 0!important;min-height:0!important}.shopify-section:has(.pawlab-plp-crumb) h1{margin:0 0 .15rem!important;padding:0!important;line-height:1.15!important;font-size:clamp(1.35rem,5vw,1.65rem)!important}.shopify-section:has(.collection-wrapper),.shopify-section:has(#ResultsList){padding-block-start:0!important;min-height:0!important}}";
        var s = document.createElement("style");
        s.id = "pawlab-plp-filters-fix-v1-js";
        s.textContent = css;
        (document.head || document.documentElement).appendChild(s);
      } catch (e) {}
    })();

    // PLP filters bootstrap — CATEGORY collections only (not Shop All / All / New In)
    (function ensurePlpFiltersBootstrap() {
      try {
        var path = location.pathname || "";
        if (path.indexOf("/collections/") === -1) return;
        var cats = {"sofa-cover":1,"couch-covers":1,"plp-couch-covers":1,"pet-beds-blankets":1,"beds-blankets":1,"plp-beds-blankets":1,"plp-beds":1,"carriers-and-travel":1,"carriers-travel":1,"plp-carriers-travel":1,"cat-essentials":1,"cat-supplies":1,"plp-cat-supplies":1,"pet-stairs-ramps":1,"pet-stairs":1,"plp-pet-stairs":1};
        var parts = path.split("/").filter(Boolean);
        var handle = "";
        for (var i = 0; i < parts.length; i++) {
          if (parts[i] === "collections" && parts[i + 1]) {
            handle = parts[i + 1];
            break;
          }
        }
        if (!cats[handle]) return;
        if (document.getElementById("pawlab-plp-vendor-hide-v4-js")) return;
        var hide = document.createElement("style");
        hide.id = "pawlab-plp-vendor-hide-v4-js";
        hide.textContent =
          '/* pawlab-vendor-hide-v4 */accordion-custom[data-filter-param-name*="vendor"],accordion-custom[data-filter-param-name*="product-type"],accordion-custom[data-filter-param-name*="product_type"],details[id*="filter-p-vendor"],details[id*="filter-p-product-type"],details[id*="filter-p-product_type"],details[data-pawlab-hidden-facet="1"],.facets__item[data-pawlab-hidden-facet="1"],accordion-custom[data-pawlab-hidden-facet="1"],#facet-inputs-filter-p-vendor,#facet-inputs-component-filter-p-vendor{display:none!important;height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;border:0!important;visibility:hidden!important;pointer-events:none!important}.pawlab-plp-extra-filters{display:flex!important;flex-direction:column;gap:.25rem;margin:0 0 .5rem;width:100%}.pawlab-plp-extra-filters .pawlab-facet-item,.pawlab-plp-extra-filters .pawlab-facet{display:block!important;visibility:visible!important}';
        (document.head || document.documentElement).appendChild(hide);
      } catch (e) {}
    })();

    // Mobile collection gutters — works even when ZH locale page_cache serves stale Liquid
    (function ensurePlpMobileGutters() {
      try {
        if (document.getElementById("pawlab-plp-mobile-gutter-v4-js")) return;
        var css =
          "@media screen and (max-width:749px){" +
          ".shopify-section:has(.pawlab-plp-crumb),.shopify-section:has(.collection-wrapper),.shopify-section:has(#ResultsList)," +
          ".product-grid-container,results-list.section,.facets-controls-wrapper,#ResultsList,.collection-wrapper{" +
          "padding-inline:.35rem!important;--page-margin:.35rem!important;--full-page-grid-margin:.35rem!important;" +
          "--padding-inline-start:.35rem!important;--padding-inline-end:.35rem!important;--pawlab-plp-gutter:.35rem!important;" +
          "box-sizing:border-box!important}" +
          ".shopify-section:has(.pawlab-plp-crumb) .section--page-width{padding-inline:0!important;max-width:none!important;width:100%!important}" +
          ".pawlab-plp-crumb{padding-inline:0!important;margin:0 0 .15rem!important}" +
          ".shopify-section:has(.pawlab-plp-crumb) h1{margin:0!important;padding:0!important;line-height:1.15!important;" +
          "font-size:clamp(1.35rem,5vw,1.65rem)!important}" +
          ".product-grid product-card .product-title,.product-grid .product-title{padding-inline:0!important;margin-block:.12rem 0!important}" +
          "}";
        var s = document.createElement("style");
        s.id = "pawlab-plp-mobile-gutter-v4-js";
        s.textContent = css;
        (document.head || document.documentElement).appendChild(s);
      } catch (e) {}
    })();

    var path = location.pathname || "/";
    var htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    var isEn =
      path === "/en" ||
      path.indexOf("/en/") === 0 ||
      htmlLang === "en" ||
      htmlLang.indexOf("en-") === 0;
    var loc = window.__pawlabLocale || null;
    if (loc) {
      if (loc.titleEn === "Gift & Holiday" || loc.titleEn === "禮物＆節日") loc.titleEn = "Gifts for Pets";
      if (loc.titleZh === "Gift & Holiday" || loc.titleZh === "禮物＆節日" || loc.titleZh === "Gifts for Pets") {
        loc.titleZh = "毛孩節日禮";
      }
      if (loc.seoEn === "Gift & Holiday" || loc.seoEn === "禮物＆節日") loc.seoEn = "Gifts for Pets";
      if (loc.seoZh === "Gift & Holiday" || loc.seoZh === "禮物＆節日" || loc.seoZh === "Gifts for Pets") {
        loc.seoZh = "毛孩節日禮";
      }
    }
    if (loc && loc.lang && String(loc.lang).indexOf("zh") === 0) isEn = false;
    if (loc && loc.lang === "en") isEn = true;

    var brand = "PawLab & Studio";
    var desc = isEn
      ? brand +
        " — premium pet furniture and lifestyle for Hong Kong homes. Couch covers, beds, carriers, and cat essentials."
      : brand + " — 香港優質寵物傢俬與生活用品。梳化套、寵物床、外出袋與貓咪用品。";
    var homeTitle = isEn
      ? brand + " | Premium Pet Furniture Hong Kong"
      : brand + " | 香港優質寵物傢俬";
    var heading = isEn ? "Shop by Category" : "探索產品類別";
    var isProductPage = path.indexOf("/products/") !== -1;
    var isCollectionPage = /\/collections\/[^/]+/.test(path) && !isProductPage;
    var isHome =
      path === "/" ||
      path === "/en" ||
      path === "/en/" ||
      path === "/zh-TW" ||
      path === "/zh-TW/" ||
      path === "/zh-CN" ||
      path === "/zh-CN/";

    var LAUNCH_PROMO_EN = "Free shipping, sitewide";
    var LAUNCH_PROMO_ZH = "開幕優惠｜全場免運";
    function launchPromoCopy() {
      return isEn ? LAUNCH_PROMO_EN : LAUNCH_PROMO_ZH;
    }
    function launchPromoLooksLike(text) {
      var t = (text || "").replace(/\s+/g, " ").trim();
      if (!t) return false;
      if (t === LAUNCH_PROMO_EN || t === LAUNCH_PROMO_ZH) return true;
      if (/through 30 Sep|ends 30 Sep|至 9月30日|即日至 9月30日|優惠至 9月30日/i.test(t)) return true;
      if (/free shipping/i.test(t) && /sitewide|every order|all orders/i.test(t)) return true;
      if (t.indexOf("全場免運") !== -1 || t.indexOf("全單免運") !== -1) return true;
      return false;
    }
    function launchPromoActive() {
      if (window.PAWLAB_LAUNCH_FREE_SHIP === false) return false;
      var el = document.querySelector(".announcement-bar__text");
      if (!el) return false;
      return launchPromoLooksLike(el.textContent);
    }
    function ensureLaunchPromoBanner() {
      try {
        if (/\/checkouts?(\/|$)/.test(path) || (window.Shopify && Shopify.Checkout)) return;
        var copy = launchPromoCopy();
        document.querySelectorAll(".announcement-bar__text").forEach(function (el) {
          var t = (el.textContent || "").replace(/\s+/g, " ").trim();
          if (!t) return;
          if (launchPromoLooksLike(t) && t !== copy) el.textContent = copy;
        });
        var bar = document.querySelector(".announcement-bar");
        if (bar && launchPromoActive()) {
          bar.classList.add("pawlab-launch-promo-bar");
          if (!document.getElementById("pawlab-launch-promo-bar-css")) {
            var s = document.createElement("style");
            s.id = "pawlab-launch-promo-bar-css";
            s.textContent =
              ".announcement-bar.pawlab-launch-promo-bar,.pawlab-launch-promo-bar{" +
              "background:#2c2926!important;color:#f4efe8!important;" +
              "--color-background:#2c2926;--color-foreground:#f4efe8;" +
              "border-block-end:0!important}" +
              ".pawlab-launch-promo-bar .announcement-bar__text{" +
              "font-size:.75rem;font-weight:500;letter-spacing:.04em;line-height:1.4;" +
              "color:#f4efe8!important;text-transform:none!important;margin:0;text-align:center}";
            (document.head || document.documentElement).appendChild(s);
          }
        }
      } catch (e) {}
    }

    function scrubLegacyBrand(text) {
      if (!text) return text;
      return String(text)
        .replace(/vitalpawhk\s*香港/gi, brand)
        .replace(/Vitalpaw\s*香港/gi, brand)
        .replace(/Vitalpaw\s*Hong Kong/gi, brand)
        .replace(/VitalPaw\s*HK/gi, brand)
        .replace(/Vitalpaw/gi, brand)
        .replace(/VitalPaw/gi, brand);
    }

    // Homepage / legacy shop titles → PawLab & Studio
    (function fixBrandTitle() {
      try {
        var t = document.title || "";
        var scrubbed = scrubLegacyBrand(t);
        if (isHome || /vitalpaw/i.test(t)) {
          document.title = isHome ? homeTitle : scrubbed;
        } else if (scrubbed !== t) {
          document.title = scrubbed;
        }
        var siteEl = document.querySelector('meta[property="og:site_name"]');
        if (siteEl) siteEl.setAttribute("content", brand);
        [
          'meta[property="og:title"]',
          'meta[name="twitter:title"]',
        ].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (!el) return;
          var c = el.getAttribute("content") || "";
          if (isHome || /vitalpaw/i.test(c)) {
            el.setAttribute("content", isHome ? homeTitle : scrubLegacyBrand(c));
          }
        });
      } catch (e) {}
    })();

    function splitLocale(text) {
      if (!text || text.indexOf("|") === -1) return text;
      var parts = text.split(/\s*\|\s*/);
      if (parts.length < 2) return text;
      return isEn ? parts[0].trim() : parts.slice(1).join(" | ").trim();
    }
    function setMeta(sel, content) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute("content", content);
      });
    }
    function inProductCard(el) {
      return !!(
        el.closest &&
        el.closest(
          "product-card, .product-card, results-list, .product-grid, ul.product-grid, related-products, .related-products, .resource-list, [data-product-card]"
        )
      );
    }

    function replaceTextMap(root, map) {
      if (!root) return;
      var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walk.nextNode())) {
        if (node.parentElement && node.parentElement.closest("[data-pawlab-plp-filters], .pawlab-plp-extra-filters")) continue;
        var v = (node.nodeValue || "").replace(/\s+/g, " ").trim();
        if (!v) continue;
        if (map[v]) {
          // preserve surrounding whitespace of original nodeValue lightly
          node.nodeValue = node.nodeValue.replace(v, map[v]);
        }
      }
    }

    function localizeSearchTitles() {
      document
        .querySelectorAll(".resource-card__title.pawlab-locale-title, .pawlab-locale-title[data-pawlab-title-zh]")
        .forEach(function (el) {
          var zh = el.getAttribute("data-pawlab-title-zh");
          var en = el.getAttribute("data-pawlab-title-en");
          var next = isEn ? en : zh;
          if (next && (el.textContent || "").trim() !== next) el.textContent = next;
        });
    }

    function localizeNavLabels() {
      var mapZh = {
        "About Us": "關於我們",
        About: "關於我們",
        "Shipping & Delivery": "運送及配送",
        "Terms and Conditions": "條款及細則",
        "Privacy Policy": "私隱政策",
        "Returns & Refunds": "退換貨及退款",
        "Payment Options": "付款方式",
        "Contact Us": "聯絡我們",
        "Contact Us | 聯絡我們": "聯絡我們",
        "Shop All": "全部商品",
        "Shop by Category": "按類別選購",
        "New Arrivals": "新品上架",
        "Couch Covers": "梳化套",
        "Beds & Blankets": "寵物床及毛毯",
        "Cat Supplies": "貓咪用品",
        "Carriers & Travel": "外出袋及旅行用品",
        "Products for Pet Parents": "寵物爸媽專區",
        Deals: "優惠專區",
        Info: "資訊",
        Help: "客戶支援",
        Links: "連結",
        "Partner with us": "與我們合作",
        "Subscribe to our emails": "登記收取最新消息",
        "Sign up to receive the latest updates": "登記收取最新消息",
        "Email address": "電子郵件地址",
        "Sign up": "登記",
        "Shop collections": "瀏覽系列",
        "Send message": "傳送訊息",
        "Pet Stairs": "寵物梯及斜坡",
        "Pet Stairs & Ramps": "寵物梯及斜坡",
        "Gift & Holiday": "毛孩節日禮",
        "Gifts for Pets": "毛孩節日禮",
        "禮物＆節日": "毛孩節日禮",
        "You may also like": "你可能也會喜歡",
        "You may also like ": "你可能也會喜歡",
        "Related products": "相關產品",
        "Related Products": "相關產品"
      };
      var mapEn = {};
      Object.keys(mapZh).forEach(function (k) {
        mapEn[mapZh[k]] = k.indexOf("|") !== -1 ? k.split("|")[0].trim() : k;
      });
      mapEn["外出袋及旅行"] = "Carriers & Travel";
      mapEn["運送及送貨"] = "Shipping & Delivery";
      mapEn["Shop by Catergory"] = "Shop by Category";
      mapEn["毛孩節日禮"] = "Gifts for Pets";
      mapEn["禮物＆節日"] = "Gifts for Pets";
      mapEn["Gift & Holiday"] = "Gifts for Pets";
      var map = isEn ? mapEn : mapZh;
      document
        .querySelectorAll(
          ".menu__item a, .menu a, .footer-block a, .header-menu a, .header-drawer a, .menu-drawer a, nav a, .footer a, .button, button, a.button"
        )
        .forEach(function (a) {
          if (!a || a.closest("script") || a.closest("style")) return;
          // Product category facet label is locked: EN "Gift & Holiday".
          if (a.closest("[data-pawlab-plp-filters], .pawlab-plp-extra-filters")) return;
          var t = (a.textContent || "").replace(/\s+/g, " ").trim();
          if (t.indexOf("Catergory") !== -1 || t.indexOf("catergory") !== -1) {
            a.textContent = isEn ? "Shop by Category" : "按類別選購";
            return;
          }
          if (map[t]) a.textContent = map[t];
        });
    }

    function localizeUiCopy() {
      var mapZh = {
        "Frequently asked questions": "常見問題",
        "You may also like": "你可能也會喜歡",
        "You may also like ": "你可能也會喜歡",
        "Related products": "相關產品",
        "Related Products": "相關產品",
        "How long does delivery take in Hong Kong?": "香港送貨需要多久？",
        "Do you offer free shipping?": "有提供免費送貨嗎？",
        "How do I choose the right size?": "如何選擇正確尺寸？",
        "How do I choose the right size for covers, beds, or stairs?": "梳化套、寵物床或寵物梯應如何選尺寸？",
        "What is your returns policy?": "退換貨政策是甚麼？",
        "How should I care for pet furniture and covers?": "寵物傢俬與保護套應如何保養？",
        "Are materials safe for pets and indoor homes?": "材質對寵物和室內家居安全嗎？",
        "Standard delivery usually takes 5–7 business days across Hong Kong Island, Kowloon, and the New Territories. Express delivery is charged according to the shipping carrier’s rates and is next business day within serviceable areas. Orders placed before 3:00 PM on weekdays are usually processed the same day. You’ll get a tracking email once your order ships.":
          "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。",
        "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        // Scrub retired free-shipping thresholds to Admin truth
        "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。":
          "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。",
        "Free standard delivery across Hong Kong on orders over HK$500. Orders under HK$500: HK$30. Usually 2–3 business days.":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "Free standard delivery across Hong Kong on orders over HK$500. Orders under HK$500: HK$30. Usually 5–7 business days.":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "標準送貨一般需 2–3 個工作天，覆蓋港島、九龍及新界。特快送貨（HK$50）於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。":
          "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。",
        "標準送貨一般需 2–3 個工作天，覆蓋港島、九龍及新界。特快送貨（HK$50）於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。":
          "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。",
        // Shipping policy page bullets (Translate & Adapt)
        "本地標準送貨免費，不設金額門檻": "本地標準送貨免費，不設金額門檻",
        "海外標準及特快送貨，訂單達 HK$300 起免費": "海外標準及特快送貨，訂單達 HK$300 起免費",
        "約 2–3 個工作天": "約 5–7 個工作天",
        "Local standard delivery is free, with no order minimum": "Local standard delivery is free, with no order minimum",
        "International Standard and Expedited delivery are free from HK$300": "International Standard and Expedited delivery are free from HK$300",
        "Usually 2–3 business days": "Usually 5–7 business days",
                "Free local delivery": "Free local delivery",
        "本地標準送貨免費": "本地標準送貨免費",
        "Free standard delivery across Hong Kong on orders over HK$300. Orders under HK$300: HK$30. Usually 2–3 business days.":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。":
          "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。",
        "Check the size guide on each product page and measure your sofa, your pet’s weight/shoulder height, or the floor space you have. For sofa covers, match the listed length and seat range to your furniture; for stairs and ramps, check height and weight capacity. If you’re unsure, email hello@pawlabandstudio.com with a photo or measurements — we’re happy to help.":
          "請先參閱每件產品頁的尺碼指南，並量度你的梳化、毛孩體重／肩高，或家中可用的地面空間。梳化套請對照所列長度與座面範圍；寵物梯／斜坡請核對高度與承重。如不確定，可電郵 hello@pawlabandstudio.com 並附上照片或尺寸，我們樂意協助。",
        "Unused items in original condition can be returned within 14 days of delivery. Contact hello@pawlabandstudio.com with your order number — we’ll arrange return authorization and pickup. Items damaged in transit are eligible for replacement or refund. See our Returns & Refunds page for full details.":
          "未使用且保持原狀的貨品，可於收貨後 14 天內退貨。請電郵 hello@pawlabandstudio.com 並提供訂單編號——我們會安排退貨授權及收回。運送途中損壞的貨品可安排更換或退款。詳情請見「退換貨政策」頁。",
        "Follow the care notes on the product page. Many removable covers are machine-washable on a gentle cycle; air-dry when possible to keep fabric shape. Vacuum or brush sisal and fabric surfaces regularly, and avoid harsh bleach unless the care label allows it. Wipe waterproof or stain-resistant surfaces with a damp cloth for everyday clean-ups.":
          "請依照產品頁的保養說明。多數可拆外套可用柔洗程序機洗；盡量陰乾以保持布料形狀。劍麻與布面請定時吸塵或輕刷；除非保養標籤註明可用，否則避免使用強烈漂白水。防水或防污表面日常用濕布擦拭即可。",
        "We focus on non-food pet furniture and lifestyle — sofa covers, beds, carriers, cat trees, stairs, and home accessories — made for indoor use. Each product page lists main materials and intended use. If your pet chews fabric or has sensitivities, contact us before ordering and we’ll help you pick a suitable option.":
          "我們專注非食品類寵物傢俬與生活用品——梳化套、寵物床、外出袋、貓樹、寵物梯及家居配件——專為室內使用而設。每件產品頁會列明主要材質與用途。如毛孩會咬布料或有敏感情況，請於下單前聯絡我們，我們會協助你揀選合適產品。",
        // Scrub stale Translate & Adapt FAQ (matches old screenshot copy)
        "常見問題解答": "常見問題",
        "貨物運送到香港需要多長時間？": "香港送貨需要多久？",
        "你們有提供免運費服務嗎？": "有提供免費送貨嗎？",
        "這些補充劑是否安全並符合法規？": "材質對寵物和室內家居安全嗎？",
        "如果我的寵物不喜歡這個產品，我可以退貨嗎？": "退換貨政策是甚麼？",
        "我如何知道哪種產品適合我的寵物？": "梳化套、寵物床或寵物梯應如何選尺寸？",
        "Are these supplements safe and compliant?": "Are materials safe for pets and indoor homes?",
        "Which product is best for my pet?": "How do I choose the right size for covers, beds, or stairs?",
        "What if my pet doesn't like the product?": "What is your returns policy?",
        "What if my pet doesn't like this product?": "What is your returns policy?",
        "Shop collections": "瀏覽系列",
        "Send message": "傳送訊息",
        "Couch Covers": "梳化套",
        "Beds & Blankets": "寵物床及毛毯",
        "Carriers & Travel": "外出袋及旅行用品",
        "Pet Stairs": "寵物梯及斜坡",
        "Cat Supplies": "貓咪用品",
        "Add to cart": "加入購物車",
        "Sold out": "已售罄",
        "Filter": "篩選",
        "Sort": "排序",
        "Availability": "有貨情況",
        "In stock": "有現貨",
        "Out of stock": "缺貨",
        "Product type": "產品類型",
        "Color": "顏色",
        "Size": "尺碼",
        "Use case": "使用場景",
        Interior: "室內",
        Exterior: "戶外／外出",
        Vendor: "品牌"
      };

      // Express fee copy: drop retired flat fees
      mapZh[
        "Standard delivery usually takes 5–7 business days across Hong Kong Island, Kowloon, and the New Territories. Express delivery is charged according to the shipping carrier’s rates and is next business day within serviceable areas. Orders placed before 3:00 PM on weekdays are usually processed the same day. You’ll get a tracking email once your order ships."
      ] =
        "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。";
      mapZh[
        "Standard delivery usually takes 2–3 business days across Hong Kong Island, Kowloon, and the New Territories. Express delivery (HK$50) is next business day within serviceable areas. Orders placed before 3:00 PM on weekdays are usually processed the same day. You’ll get a tracking email once your order ships."
      ] =
        "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。";
      mapZh["標準送貨一般需 2–3 個工作天，覆蓋港島、九龍及新界。特快送貨（HK$50）於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。"] = "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前的訂單一般即日處理；貨品寄出後你會收到附追蹤編號的電郵。";
      mapZh["標準送貨一般需 2–3 個工作天，覆蓋港島、九龍及新界。特快送貨（HK$50）於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。"] = "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。";

      var mapEn = {};
      Object.keys(mapZh).forEach(function (k) {
        mapEn[mapZh[k]] = k;
      });
      mapEn["本地標準送貨免費"] = "Free local delivery";
      mapEn["有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"] = "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.";
      mapEn["本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"] = "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.";
      mapEn["本地標準送貨免費，不設金額門檻"] = "Local standard delivery is free, with no order minimum";
      mapEn["海外標準及特快送貨，訂單達 HK$300 起免費。"] = "International Standard and Expedited delivery are free from HK$300.";
      mapEn["Are materials safe for pets and indoor homes?"] = "Are materials safe for pets and indoor homes?";
      mapEn["How do I choose the right size for covers, beds, or stairs?"] = "How do I choose the right size for covers, beds, or stairs?";
      mapEn["What is your returns policy?"] = "What is your returns policy?";
      mapEn["How long does delivery take in Hong Kong?"] = "How long does delivery take in Hong Kong?";
      mapEn["Do you offer free shipping?"] = "Do you offer free shipping?";
      var map = isEn ? mapEn : mapZh;
      var root = document.querySelector("#MainContent") || document.body;
      replaceTextMap(root, map);
      var holidayTitleScrub = isEn
        ? { "Gift & Holiday": "Gifts for Pets", "禮物＆節日": "Gifts for Pets" }
        : { "Gift & Holiday": "毛孩節日禮", "Gifts for Pets": "毛孩節日禮", "禮物＆節日": "毛孩節日禮" };
      replaceTextMap(root, holidayTitleScrub);
      document.querySelectorAll("[aria-label]").forEach(function (el) {
        var label = el.getAttribute("aria-label");
        if (label && holidayTitleScrub[label]) el.setAttribute("aria-label", holidayTitleScrub[label]);
      });

      // One-way shipping scrub. Local standard delivery is free. International Standard and Expedited delivery are free from HK$300.
      var shipScrub = {};
      var shipPairs = [
        ["FREE SHIPPING (ORDERS ≥ HK$500)", "Free local delivery", "本地標準送貨免費"],
        ["FREE SHIPPING (ORDERS ≥ HK$300)", "Free local delivery", "本地標準送貨免費"],
        ["免費送貨（滿 HK$500）", "Free local delivery", "本地標準送貨免費"],
        ["免費送貨（滿 HK$300）", "Free local delivery", "本地標準送貨免費"],
        ["Free for orders over HK$500", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["Free for orders over HK$300", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["for orders over HK$500", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["for orders over HK$300", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["滿 HK$500 免運費", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["滿 HK$300 免運費", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["滿 HK$500 全港免運（標準送貨）", "Free local delivery", "本地標準送貨免費"],
        ["滿 HK$500 免標準運費。", "Local standard delivery is free. International Standard and Expedited delivery are free from HK$300.", "本地標準送貨免費。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Free standard shipping on orders over HK$500.", "Local standard delivery is free. International Standard and Expedited delivery are free from HK$300.", "本地標準送貨免費。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Free standard delivery across Hong Kong on orders over HK$500", "Local standard delivery is free. International Standard and Expedited delivery are free from HK$300.", "本地標準送貨免費。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["訂單滿 HK$500 免運費", "Local standard delivery is free, with no order minimum", "本地標準送貨免費，不設金額門檻"],
        ["Yes — free standard shipping on orders over HK$500. Orders under HK$500 are charged by package weight according to the shipping carrier’s rates. International shipping is available; fees follow the shipping carrier’s rates.", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Yes — for local Hong Kong orders, free standard shipping on orders over HK$500; under HK$500, shipping is charged by package weight at the carrier’s rates. International shipping is not free — fees are charged based on the courier’s rates.", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Yes — free standard shipping on orders over HK$500. Orders under HK$500 have a HK$30 flat shipping fee. We currently deliver within Hong Kong only.", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Yes — free standard shipping on orders over HK$300. Orders under HK$300 have a HK$30 flat shipping fee. We currently deliver within Hong Kong only.", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["有——訂單滿 HK$500 享免費標準送貨；未滿 HK$500 則按貨品重量依運送承運商收費計算運費。亦提供海外運送，運費按運送承運商收費計算。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["有——香港本地訂單滿 HK$500 享免費標準送貨；未滿 HK$500 則按貨品重量依運送承運商收費計算運費。海外／國際運送不設免運，運費一律按運送承運商（courier）收費計算。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["有——訂單滿 HK$500 享免費標準送貨；未滿 HK$500 劃一運費 HK$30。我們目前只送香港本地。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["可以——訂單滿 HK$300 享免費標準送貨；未滿 HK$300 運費 HK$30。目前只送香港本地。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["有——訂單滿 HK$300 享免費標準送貨；未滿 HK$300 劃一運費 HK$30。我們目前只送香港本地。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Free standard delivery across Hong Kong on orders over HK$500. Orders under HK$500 are charged by package weight according to the shipping carrier’s rates. Usually 5–7 business days.", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["Free standard delivery across Hong Kong on orders over HK$500. Orders under HK$500: HK$30. Usually 2–3 business days.", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["Free standard delivery across Hong Kong on orders over HK$500. Orders under HK$500: HK$30. Usually 5–7 business days.", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["Free standard delivery across Hong Kong on orders over HK$300. Orders under HK$300: HK$30. Usually 2–3 business days.", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["香港地區訂單滿 HK$500 享免費標準送貨；未滿 HK$500 則按貨品重量依運送承運商收費計算運費。一般 5–7 個工作天送達。", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["香港地區訂單滿 HK$500 享免費標準送貨；未滿 HK$500 運費 HK$30。一般 2–3 個工作天送達。", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["香港地區訂單滿 HK$500 享免費標準送貨；未滿 HK$500 運費 HK$30。一般 5–7 個工作天送達。", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["香港地區訂單滿 HK$300 享免費標準送貨；未滿 HK$300 運費 HK$30。一般 2–3 個工作天送達。", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["Orders under HK$500 are charged by package weight according to the shipping carrier’s rates", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Charged by package weight according to the shipping carrier’s rates for orders under HK$500", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["HK$30 for orders under HK$300", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["未滿 HK$500 則按貨品重量依運送承運商收費計算運費", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["未滿 HK$500 按貨品重量依運送承運商收費計算運費", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["未滿 HK$300 收取 HK$30", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["We currently deliver within Hong Kong only.", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["We currently ship within Hong Kong only.", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["我們目前只送香港本地。", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["目前只提供香港本地送貨。", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["International shipping is available; fees follow the shipping carrier’s rates.", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["International shipping is available. Fees follow the shipping carrier’s rates.", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["亦提供海外運送，運費按運送承運商收費計算。", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["提供海外運送，運費將按運送承運商收費計算。", "International Standard and Expedited delivery are free from HK$300.", "海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Express delivery (HK$50) is next business day within serviceable areas.", "Express delivery is charged according to the shipping carrier’s rates and is next business day within serviceable areas.", "特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。"],
        ["特快送貨（HK$50）於服務範圍內可於下一個工作天送達。", "Express delivery is charged according to the shipping carrier’s rates and is next business day within serviceable areas.", "特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。"],
        ["Usually 2–3 business days", "Usually 5–7 business days", "一般需 5–7 個工作天"],
        ["約 2–3 個工作天", "Usually 5–7 business days", "約 5–7 個工作天"],
        ["Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。", "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.", "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。"],
        ["Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。", "Local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300. Usually 5–7 business days.", "本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。一般 5–7 個工作天送達。"],
        ["Free local delivery", "Free local delivery", "本地標準送貨免費"],
        ["本地標準送貨免費", "Free local delivery", "本地標準送貨免費"],
      ];
      shipPairs.forEach(function (row) {
        shipScrub[row[0]] = isEn ? row[1] : row[2];
      });
      replaceTextMap(root, shipScrub);

      // Admin truth: do not rewrite shipping badges, FAQ, or policy into sitewide free shipping.

      // Facet / filter labels that may be in inputs or spans
      document
        .querySelectorAll(
          ".facets__label, .facet-filters__label, .facets-controls-wrapper span, .filter-group summary, .facets summary, legend"
        )
        .forEach(function (el) {
          var t = (el.textContent || "").replace(/\s+/g, " ").trim();
          if (map[t]) el.textContent = map[t];
        });
    }

    function localizePageLocaleBlocks() {
      document.querySelectorAll(".pawlab-page-locale[data-pawlab-en]").forEach(function (el) {
        el.style.display = isEn ? "" : "none";
      });
      document.querySelectorAll(".pawlab-page-locale[data-pawlab-zh]").forEach(function (el) {
        el.style.display = isEn ? "none" : "";
      });
      // Page title H1 Contact Us | 聯絡我們
      document.querySelectorAll("h1, .page-title, .main-page-title").forEach(function (h) {
        if (inProductCard(h)) return;
        var t = (h.textContent || "").replace(/\s+/g, " ").trim();
        if (t.indexOf("|") !== -1 && t.length < 80) {
          h.textContent = splitLocale(t);
        } else if (!isEn && t === "Contact Us") {
          h.textContent = "聯絡我們";
        } else if (isEn && t === "聯絡我們") {
          h.textContent = "Contact Us";
        }
      });
    }

    // Prefer metafield-driven page titles when present — never stamp onto product cards
    if (loc) {
      var t = isEn ? loc.titleEn : loc.titleZh;
      var s = isEn ? loc.seoEn : loc.seoZh;
      if (t) {
        if (isProductPage) {
          var pdpTitle = null;
          document
            .querySelectorAll(
              "h1.product-title, .product-information .product-title, .product-information .text-block h1, .product-details .text-block h1, .product-details h1"
            )
            .forEach(function (el) {
              if (inProductCard(el)) return;
              if (!pdpTitle) pdpTitle = el;
            });
          if (pdpTitle) pdpTitle.textContent = t;
          document.querySelectorAll('[data-testid="sticky-product-title"], .sticky-add-to-cart__title').forEach(function (el) {
            // sticky often "Title / Variant" — replace title prefix
            var cur = (el.textContent || "").trim();
            if (!cur) return;
            if (loc.titleEn && cur.indexOf(loc.titleEn) === 0) {
              el.textContent = cur.replace(loc.titleEn, t);
            } else if (loc.titleZh && cur.indexOf(loc.titleZh) === 0) {
              el.textContent = cur.replace(loc.titleZh, t);
            } else if (cur.indexOf(" / ") === -1 && cur.indexOf("／") === -1) {
              el.textContent = t;
            }
          });
          document.querySelectorAll(".pawlab-pdp-crumb__item--current [itemprop='name'], .pawlab-pdp-crumb__item--current span").forEach(function (el) {
            if ((el.textContent || "").trim() === loc.titleEn || (el.textContent || "").trim() === loc.titleZh) {
              el.textContent = t;
            }
          });
        } else if (isCollectionPage) {
          document.querySelectorAll("h1").forEach(function (el) {
            if (el.classList.contains("product-title")) return;
            if (inProductCard(el)) return;
            var cur = (el.textContent || "").trim();
            if (cur && cur.length < 120) el.textContent = t;
          });
        }
        var shop = document.title.split(/\s*[–—]\s*/);
        document.title = t + (shop.length > 1 ? " – " + shop.slice(1).join(" – ") : "");
        setMeta('meta[property="og:title"]', t);
        setMeta('meta[name="twitter:title"]', t);
      }
      if (s) {
        setMeta('meta[name="description"]', s);
        setMeta('meta[property="og:description"]', s);
        setMeta('meta[name="twitter:description"]', s);
      }
    } else {
      var isProductOrCollection =
        path.indexOf("/products/") !== -1 || path.indexOf("/collections/") !== -1;
      if (!isProductOrCollection) {
        var metaDesc = desc;
        if (path.indexOf("shipping-and-delivery") !== -1 || path.indexOf("shipping-delivery") !== -1) {
          metaDesc = isEn
            ? "Local standard delivery is free. International Standard and Expedited delivery are free from HK$300."
            : "本地標準送貨免費。海外標準及特快送貨，訂單達 HK$300 起免費。";
        }
        setMeta('meta[name="description"]', metaDesc);
        setMeta('meta[property="og:description"]', metaDesc);
        setMeta('meta[name="twitter:description"]', metaDesc);
      } else {
        document
          .querySelectorAll(
            'meta[name="description"],meta[property="og:description"],meta[name="twitter:description"],meta[property="og:title"],meta[name="twitter:title"]'
          )
          .forEach(function (el) {
            var c = el.getAttribute("content") || "";
            var n = splitLocale(c);
            if (n && n !== c) el.setAttribute("content", n);
          });
        if (document.title && document.title.indexOf("|") !== -1) {
          var titleParts = document.title.split(/\s*[–—-]\s*/);
          var main = splitLocale(titleParts[0] || document.title);
          var rest = titleParts.slice(1).join(" – ");
          document.title = rest ? main + " – " + rest : main;
        }
      }
    }

    document.querySelectorAll(".text-block,[class*='text_fRMQMR']").forEach(function (el) {
      if (inProductCard(el)) return;
      var t = (el.textContent || "").trim();
      if (t.indexOf('"type":"root"') !== -1) {
        var m = t.match(/"value"\s*:\s*"([^"]+)"/);
        el.innerHTML = "<h1>" + (m && m[1] ? m[1] : heading) + "</h1>";
      }
    });
    document.querySelectorAll("h1,h2").forEach(function (h) {
      if (h.classList.contains("product-title")) return;
      if (inProductCard(h)) return;
      var t = (h.textContent || "").trim();
      if (t.indexOf("Catergory") !== -1 || t.indexOf("catergory") !== -1) h.textContent = heading;
      if (isEn && t.indexOf("探索產品類別") !== -1) h.textContent = heading;
      if (t.indexOf('"type":"root"') !== -1) {
        var m = t.match(/"value"\s*:\s*"([^"]+)"/);
        h.textContent = m && m[1] ? m[1] : heading;
        return;
      }
      if (!loc && t.indexOf("|") !== -1 && t.length < 120) {
        var n = splitLocale(t);
        if (n && n !== t) h.textContent = n;
      }
    });


    function repairPdpFaq() {
      if (!isProductPage) return;
      if (document.querySelector(".pawlab-pdp-faq")) return; // already correct template
      var stale =
        document.body.innerHTML.indexOf("補充劑") !== -1 ||
        document.body.innerHTML.indexOf("supplements") !== -1 ||
        document.body.innerHTML.indexOf("哪種產品適合我的寵物") !== -1 ||
        document.body.innerHTML.indexOf("Which product is best for my pet") !== -1 ||
        !!document.querySelector('[id*="__section_cPTRK4"]');
      if (!stale) return;
      var host =
        document.querySelector('[id*="__section_cPTRK4"]') ||
        document.querySelector('[id*="__pawlab_pdp_faq"]') ||
        null;
      // Prefer replacing the FAQ accordion block
      var accordion = document.querySelector('[id*="__section_cPTRK4"] .accordion, [id*="__section_cPTRK4"]');
      var target = host || accordion;
      if (!target) return;

      var faqShipEn = "Yes — local standard delivery is free, with no order minimum. International Standard and Expedited delivery are free from HK$300.";
      var faqShipZh = "有——本地標準送貨免費，不設金額門檻。海外標準及特快送貨，訂單達 HK$300 起免費。";
      var items = isEn
        ? [
            ["How long does delivery take in Hong Kong?", "Standard delivery usually takes 5–7 business days across Hong Kong Island, Kowloon, and the New Territories. Express delivery is charged according to the shipping carrier’s rates and is next business day within serviceable areas. Orders placed before 3:00 PM on weekdays are usually processed the same day. You’ll get a tracking email once your order ships."],
            ["Do you offer free shipping?", faqShipEn],
            ["How do I choose the right size for covers, beds, or stairs?", "Check the size guide on each product page and measure your sofa, your pet’s weight/shoulder height, or the floor space you have. For sofa covers, match the listed length and seat range to your furniture; for stairs and ramps, check height and weight capacity. If you’re unsure, email hello@pawlabandstudio.com with a photo or measurements — we’re happy to help."],
            ["What is your returns policy?", "Unused items in original condition can be returned within 14 days of delivery. Contact hello@pawlabandstudio.com with your order number — we’ll arrange return authorization and pickup. Items damaged in transit are eligible for replacement or refund. See our Returns & Refunds page for full details."],
            ["How should I care for pet furniture and covers?", "Follow the care notes on the product page. Many removable covers are machine-washable on a gentle cycle; air-dry when possible to keep fabric shape. Vacuum or brush sisal and fabric surfaces regularly, and avoid harsh bleach unless the care label allows it. Wipe waterproof or stain-resistant surfaces with a damp cloth for everyday clean-ups."],
            ["Are materials safe for pets and indoor homes?", "We focus on non-food pet furniture and lifestyle — sofa covers, beds, carriers, cat trees, stairs, and home accessories — made for indoor use. Each product page lists main materials and intended use. If your pet chews fabric or has sensitivities, contact us before ordering and we’ll help you pick a suitable option."]
          ]
        : [
            ["香港送貨需要多久？", "標準送貨一般需 5–7 個工作天，覆蓋港島、九龍及新界。特快送貨按運送承運商收費計算運費，於服務範圍內可於下一個工作天送達。平日下午 3 時前落單，通常即日處理。訂單寄出後，你會收到附追蹤編號的電郵。"],
            ["有提供免費送貨嗎？", faqShipZh],
            ["梳化套、寵物床或寵物梯應如何選尺寸？", "請先參閱每件產品頁的尺碼指南，並量度你的梳化、毛孩體重／肩高，或家中可用的地面空間。梳化套請對照所列長度與座面範圍；寵物梯／斜坡請核對高度與承重。如不確定，可電郵 hello@pawlabandstudio.com 並附上照片或尺寸，我們樂意協助。"],
            ["退換貨政策是甚麼？", "未使用且保持原狀的貨品，可於收貨後 14 天內退貨。請電郵 hello@pawlabandstudio.com 並提供訂單編號——我們會安排退貨授權及收回。運送途中損壞的貨品可安排更換或退款。詳情請見「退換貨政策」頁。"],
            ["寵物傢俬與保護套應如何保養？", "請依照產品頁的保養說明。多數可拆外套可用柔洗程序機洗；盡量陰乾以保持布料形狀。劍麻與布面請定時吸塵或輕刷；除非保養標籤註明可用，否則避免使用強烈漂白水。防水或防污表面日常用濕布擦拭即可。"],
            ["材質對寵物和室內家居安全嗎？", "我們專注非食品類寵物傢俬與生活用品——梳化套、寵物床、外出袋、貓樹、寵物梯及家居配件——專為室內使用而設。每件產品頁會列明主要材質與用途。如毛孩會咬布料或有敏感情況，請於下單前聯絡我們，我們會協助你揀選合適產品。"]
          ];
      var title = isEn ? "Frequently asked questions" : "常見問題";
      var html = '<div class="pawlab-pdp-faq section section--page-width" style="padding-block:0.5rem 1.25rem;max-width:52rem;margin-inline:auto;">';
      html += '<h3 class="pawlab-pdp-faq__title" style="margin:0 0 0.75rem;font-size:1.25rem;font-weight:650;line-height:1.3;color:#1a1a1a;">' + title + "</h3>";
      html += '<div class="pawlab-pdp-faq__list" style="border-top:1px solid #e8e4df;">';
      for (var i = 0; i < items.length; i++) {
        html +=
          '<details class="pawlab-pdp-faq__item" style="border-bottom:1px solid #e8e4df;"><summary style="list-style:none;cursor:pointer;padding:0.9rem 1.75rem 0.9rem 0;font-size:0.975rem;font-weight:600;line-height:1.35;color:#1a1a1a;">' +
          items[i][0] +
          '</summary><div class="pawlab-pdp-faq__body" style="padding:0 0 1rem;"><p style="margin:0;font-size:0.9375rem;line-height:1.65;color:#3a3632;">' +
          items[i][1] +
          "</p></div></details>";
      }
      html += "</div></div>";
      // Replace section inner content
      if (target.id && target.id.indexOf("shopify-section-") === 0) {
        target.innerHTML = html;
      } else if (target.closest && target.closest('[id*="shopify-section-"]')) {
        target.closest('[id*="shopify-section-"]').innerHTML = html;
      } else {
        target.outerHTML = html;
      }
    }

    function localizeQuickAddTitles() {
      // Full catalog EN→ZH map (safety net for every Quick Add product)
      var TITLE_MAP_ZH = {
        "Sisal Scratcher Nest": "劍麻貓抓板帶窩",
        "Anti-Scratch Stretch Sofa Cover": "防貓抓彈力梳化套",
        "Waterproof One-Piece Sofa Protector": "連體防水梳化保護墊",
        "Plaid Removable Pet Sofa Bed": "格紋可拆洗寵物梳化床",
        "Ribbed Removable Pet Sofa Bed": "格紋可拆洗寵物梳化床",
        "Square Four-Season Pet Bed": "四季方形寵物窩",
        "Winter Fleece Sling Pet Carrier": "秋冬絨感斜挎寵物袋",
        "Breathable Shoulder Cat Carrier": "透氣單肩貓包",
        "Waterproof Car Pet Nest Bag": "防水車載寵物窩手提包",
        "Washable Pet Stairs Ramp": "可拆洗寵物樓梯斜坡"
      };
      var TITLE_MAP_EN = {};
      Object.keys(TITLE_MAP_ZH).forEach(function (k) {
        TITLE_MAP_EN[TITLE_MAP_ZH[k]] = k;
      });
      // Prefer EN metafield key when Chinese map value collides with old EN listing title
      TITLE_MAP_EN["格紋可拆洗寵物梳化床"] = "Plaid Removable Pet Sofa Bed";

      function titleSelectors(root) {
        return (root || document).querySelectorAll(
          ".view-product-title a, .product-header a, .product-header h2, .product-header h3, h1.product-title, .product-title:not(.product-title--card)"
        );
      }

      function resolveTitle(el, preferSource) {
        if (preferSource) {
          var zh = preferSource.getAttribute("data-pawlab-title-zh");
          var en = preferSource.getAttribute("data-pawlab-title-en");
          var next = isEn ? en || preferSource.getAttribute("data-product-title") : zh || preferSource.getAttribute("data-product-title");
          if (next) return next;
        }
        var cur = (el.textContent || "").replace(/\s+/g, " ").trim();
        if (!cur) return null;
        if (isEn) return TITLE_MAP_EN[cur] || cur;
        return TITLE_MAP_ZH[cur] || cur;
      }

      document.querySelectorAll("quick-add-component[data-pawlab-title-zh], quick-add-component[data-product-title]").forEach(function (el) {
        var zh = el.getAttribute("data-pawlab-title-zh");
        var en = el.getAttribute("data-pawlab-title-en");
        var next = isEn ? en || el.getAttribute("data-product-title") : zh || el.getAttribute("data-product-title");
        if (!next) return;
        if (el.getAttribute("data-product-title") !== next) el.setAttribute("data-product-title", next);
      });

      // PDP / fetched grid content used by Quick Add (Clarity morphs [data-product-grid-content])
      document.querySelectorAll(".view-product-title").forEach(function (wrap) {
        var a = wrap.querySelector("a");
        if (!a) return;
        var next = isEn
          ? wrap.getAttribute("data-pawlab-title-en")
          : wrap.getAttribute("data-pawlab-title-zh");
        if (!next) next = resolveTitle(a, null);
        if (next && (a.textContent || "").replace(/\s+/g, " ").trim() !== next) a.textContent = next;
      });

      var modal =
        document.getElementById("quick-add-modal-content") ||
        document.querySelector(".quick-add-modal__content") ||
        document.querySelector("#quick-add-dialog .quick-add-modal");
      if (!modal) return;

      var link = modal.querySelector(".view-product-title a, .product-header a, a[href*='/products/']");
      var href = link ? link.getAttribute("href") || "" : "";
      var handleMatch = href.match(/\/products\/([^/?#]+)/);
      var handle = handleMatch ? handleMatch[1] : "";
      var source = null;
      if (handle) {
        var cardLink = document.querySelector('product-card a[href*="/products/' + handle + '"]');
        source = cardLink && cardLink.closest("product-card")
          ? cardLink.closest("product-card").querySelector("quick-add-component")
          : null;
        if (!source) {
          source = document.querySelector('quick-add-component[data-pawlab-title-zh]');
          // pick matching handle via nearby card
          document.querySelectorAll("quick-add-component").forEach(function (qa) {
            var card = qa.closest("product-card");
            if (!card) return;
            var a = card.querySelector('a[href*="/products/' + handle + '"]');
            if (a) source = qa;
          });
        }
      }
      if (!source) {
        source = document.querySelector("quick-add-component[open], quick-add-component[aria-expanded='true']");
      }

      titleSelectors(modal).forEach(function (el) {
        var next = resolveTitle(el, source);
        if (!next) return;
        if ((el.textContent || "").replace(/\s+/g, " ").trim() !== next) el.textContent = next;
      });

      // Also swap title on wrap attrs inside modal if present
      modal.querySelectorAll(".view-product-title[data-pawlab-title-zh]").forEach(function (wrap) {
        var a = wrap.querySelector("a");
        if (!a) return;
        var next = isEn ? wrap.getAttribute("data-pawlab-title-en") : wrap.getAttribute("data-pawlab-title-zh");
        if (next && (a.textContent || "").replace(/\s+/g, " ").trim() !== next) a.textContent = next;
      });
    }

    ensureLaunchPromoBanner();
    repairPdpFaq();
    localizeNavLabels();
    localizeSearchTitles();
    localizeUiCopy();
    localizePageLocaleBlocks();
    localizeQuickAddTitles();

    // PDP payment logos: Visa must sit next to Mastercard (page_cache often keeps Shopify's order)
    (function reorderPaymentIconsVisaBesideMastercard() {
      function run() {
        try {
          var list = document.querySelector(".pawlab-payment-icons__list");
          if (!list || list.getAttribute("data-pawlab-reordered") === "1") return;
          var preferred = [
            "Visa",
            "Mastercard",
            "American Express",
            "UnionPay",
            "PayPal",
            "Apple Pay",
            "Google Pay",
            "Shop Pay",
            "USDC"
          ];
          var items = Array.prototype.slice.call(list.children);
          if (!items.length) return;
          var byName = {};
          items.forEach(function (li) {
            var t = li.querySelector("title");
            var name = t ? String(t.textContent || "").trim() : "";
            var key = li.getAttribute("data-payment-type") || "";
            if (name) byName[name] = li;
            if (key === "visa") byName["Visa"] = li;
            if (key === "master") byName["Mastercard"] = li;
            if (key === "american_express") byName["American Express"] = li;
            if (key === "shopify_pay") byName["Shop Pay"] = li;
            if (key === "apple_pay") byName["Apple Pay"] = li;
            if (key === "google_pay") byName["Google Pay"] = li;
            if (key === "paypal") byName["PayPal"] = li;
            if (key === "usdc") byName["USDC"] = li;
            if (key === "unionpay") byName["UnionPay"] = li;
          });
          preferred.forEach(function (name) {
            if (byName[name] && byName[name].parentNode === list) list.appendChild(byName[name]);
          });
          items.forEach(function (li) {
            if (li.parentNode === list) list.appendChild(li);
          });
          list.setAttribute("data-pawlab-reordered", "1");
        } catch (e) {}
      }
      run();
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", run);
      }
      setTimeout(run, 50);
      setTimeout(run, 300);
    })();

    // ZH variant/SKU option labels (Liquid .values key is unreliable; JS is the safety net)
    (function localizeVariantOptionLabels() {
      if (isEn) return;

      function mergeMaps(target, src) {
        if (!src || typeof src !== "object") return target;
        var labels = src.value_labels || src.values || src;
        if (!labels || typeof labels !== "object") return target;
        Object.keys(labels).forEach(function (k) {
          if (typeof labels[k] === "string" && labels[k]) target[k] = labels[k];
        });
        return target;
      }

      function collectMap() {
        var map = {};
        try {
          document.querySelectorAll("script.pawlab-option-zh-json").forEach(function (el) {
            try {
              mergeMaps(map, JSON.parse(el.textContent || "{}"));
            } catch (e) {}
          });
        } catch (e) {}
        return map;
      }

      function applyMap(map) {
        if (!map || !Object.keys(map).length) return false;
        var changed = false;

        function swapText(el) {
          if (!el) return;
          var raw = (el.textContent || "").trim();
          if (!raw) return;
          // Strip sold-out / unavailable suffixes for lookup
          var base = raw.replace(/\s*[-–—]\s*(售罄|Sold out|Unavailable|無法提供).*$/i, "").trim();
          var zh = map[base] || map[raw];
          if (!zh || zh === raw) return;
          if (el.textContent.indexOf(base) !== -1) {
            el.textContent = el.textContent.replace(base, zh);
            changed = true;
          }
        }

        document.querySelectorAll(".variant-option__button-label__text").forEach(swapText);
        document.querySelectorAll(".variant-option__swatch-value").forEach(swapText);
        document.querySelectorAll(".variant-option__select option").forEach(swapText);

        document.querySelectorAll(".variant-option__button-label input[aria-label]").forEach(function (input) {
          var aria = input.getAttribute("aria-label") || "";
          if (!aria) return;
          var next = aria;
          Object.keys(map).forEach(function (en) {
            if (next.indexOf(en) !== -1) next = next.split(en).join(map[en]);
          });
          if (next !== aria) {
            input.setAttribute("aria-label", next);
            changed = true;
          }
        });

        // Legend / single-option rows sometimes keep English selected value
        document.querySelectorAll(".variant-option legend, .variant-option [data-testid='variant-option-single-value']").forEach(swapText);
        return changed;
      }

      var map = collectMap();
      applyMap(map);

      // Always merge global asset map on ZH (covers collection card swatches + stale PDP cache)
      try {
        var scripts = document.querySelectorAll('script[src*="pawlab-bilingual-fix.js"]');
        var assetHref = scripts.length ? scripts[0].src : "";
        var jsonHref = assetHref
          ? assetHref.replace(/pawlab-bilingual-fix\.js[^?]*/, "pawlab-option-zh-map.json")
          : "";
        if (jsonHref) {
          fetch(jsonHref, { credentials: "omit", cache: "no-cache" })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data) return;
              mergeMaps(map, data);
              applyMap(map);
            })
            .catch(function () {});
        }
      } catch (e) {}

      // Re-apply after variant picker re-renders
      try {
        var root = document.querySelector("variant-picker") || document.getElementById("MainContent");
        if (!root) return;
        var obs = new MutationObserver(function () {
          applyMap(map);
        });
        obs.observe(root, { childList: true, subtree: true });
        setTimeout(function () {
          try {
            obs.disconnect();
          } catch (e) {}
        }, 8000);
      } catch (e) {}
    })();

    // Force HK Traditional for known Simplified leftovers in page copy
    (function tradChinesePass() {
      var map = [
        ["分銷伙伴", "分銷夥伴"],
        ["合作伙伴", "合作夥伴"],
        ["伙伴", "夥伴"]
      ];
      try {
        var root = document.querySelector("#MainContent") || document.body;
        if (!root) return;
        var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walk.nextNode())) {
          var v = node.nodeValue;
          if (!v) continue;
          var next = v;
          for (var i = 0; i < map.length; i++) {
            if (next.indexOf(map[i][0]) !== -1) next = next.split(map[i][0]).join(map[i][1]);
          }
          if (next !== v) node.nodeValue = next;
        }
      } catch (e) {}
    })();

    // Re-apply when drawer/footer/facets/quick-add modal inject late
    try {
      var obs = new MutationObserver(function () {
        ensureLaunchPromoBanner();
        repairPdpFaq();
        localizeNavLabels();
        localizeSearchTitles();
        localizeUiCopy();
        localizePageLocaleBlocks();
        localizeQuickAddTitles();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      // Keep observing: Quick Add fetches PDP HTML on click after initial page load
    } catch (e) {}

    // Explicit Quick Add open hooks (all products)
    try {
      document.addEventListener(
        "click",
        function (ev) {
          var t = ev.target;
          if (!t || !t.closest) return;
          if (!t.closest("quick-add-component, .quick-add__button, .quick-add__button--choose")) return;
          setTimeout(localizeQuickAddTitles, 50);
          setTimeout(localizeQuickAddTitles, 200);
          setTimeout(localizeQuickAddTitles, 600);
          setTimeout(localizeQuickAddTitles, 1200);
        },
        true
      );
      var dialog = document.getElementById("quick-add-dialog");
      if (dialog) {
        dialog.addEventListener("toggle", function () {
          setTimeout(localizeQuickAddTitles, 30);
          setTimeout(localizeQuickAddTitles, 250);
        });
      }
    } catch (e) {}
  } catch (e) {}
})();


/* pawlab-plp-filters-embedded-v4b — new category handles */
if (!window.__pawlabPlpFiltersEmbedded) {
window.__pawlabPlpFiltersEmbedded = true;
/* pawlab-plp-filters v4 — category PLPs only; mount Color/Use case OUTSIDE vendor accordion */
(function () {
  try {
    var path = location.pathname || "";
    if (path.indexOf("/collections/") === -1) return;

    var CATEGORY_HANDLES = {
      "sofa-cover": 1,
      "couch-covers": 1,
      "plp-couch-covers": 1,
      "shop-couch-covers": 1,
      "pet-beds-blankets": 1,
      "beds-blankets": 1,
      "plp-beds-blankets": 1,
      "plp-beds": 1,
      "plp-bed-blankets": 1,
      "shop-beds-blankets": 1,
      "browse-beds-blankets": 1,
      "shop-beds": 1,
      "carriers-and-travel": 1,
      "carriers-travel": 1,
      "plp-carriers-travel": 1,
      "shop-carriers": 1,
      "cat-essentials": 1,
      "cat-supplies": 1,
      "plp-cat-supplies": 1,
      "shop-cat-supplies": 1,
      "pet-stairs-ramps": 1,
      "pet-stairs": 1,
      "plp-pet-stairs": 1,
      "shop-pet-stairs": 1
    };
    var handle = "";
    var parts = path.split("/").filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === "collections" && parts[i + 1]) {
        handle = parts[i + 1];
        break;
      }
    }
    if (!CATEGORY_HANDLES[handle]) return;

    var isEn = path === "/en" || path.indexOf("/en/") === 0;
    if (!isEn && (document.documentElement.lang || "").indexOf("zh") === 0) isEn = false;

    var LABELS = isEn
      ? { color: "Color", useCase: "Use case", interior: "Interior", exterior: "Exterior", clear: "Clear" }
      : { color: "顏色", useCase: "使用場景", interior: "室內", exterior: "戶外／外出", clear: "清除" };

    var COLOR_ZH = {
      Ivory: "象牙白", "Cookie Brown": "曲奇棕", "Storm Grey": "風暴灰", "Mist Grey": "薄霧灰",
      Green: "綠色", Black: "黑色", Grey: "灰色", Orange: "橙色", Navy: "深藍", Coffee: "咖啡",
      "Dark Grey": "深灰", Emerald: "祖母綠", "Light Coffee": "淺咖啡", Pink: "粉色",
      "Fashion Brown": "時尚棕", "Milo Grey": "米洛灰", "Grey/Red": "灰／紅", "Black/Red": "黑／紅",
      "Grey/Black": "灰／黑", "Grey/Blue": "灰／藍", "Olive Green": "橄欖綠", "Light Green": "淺綠",
      Brown: "棕色", "Smoke Grey": "煙灰", "Natural Sisal": "天然劍麻"
    };

    var PRODUCT_META = {
      "9457615274221": { use: "interior", colors: "Ivory,Cookie Brown,Storm Grey,Mist Grey,Green" },
      "9457615864045": { use: "interior", colors: "Black,Grey,Orange,Navy" },
      "9457616748781": { use: "interior", colors: "Coffee,Dark Grey" },
      "9457616978157": { use: "interior", colors: "Black,Grey,Emerald,Light Coffee,Pink" },
      "9457617043693": { use: "exterior", colors: "Fashion Brown,Milo Grey" },
      "9457617141997": { use: "exterior", colors: "Grey,Black,Grey/Red,Black/Red,Grey/Black,Grey/Blue" },
      "9457617174765": { use: "exterior", colors: "Olive Green,Pink,Light Green,Brown,Grey" },
      "9457617207533": { use: "interior", colors: "Smoke Grey" },
      "9457617240301": { use: "interior", colors: "Natural Sisal" }
    };

    function colorLabel(v) { return isEn ? v : (COLOR_ZH[v] || v); }

    function hideHost(host) {
      if (!host || host.getAttribute("data-pawlab-plp-filters")) return;
      if (host.closest && host.closest("[data-pawlab-plp-filters]")) return;
      host.style.setProperty("display", "none", "important");
      host.setAttribute("data-pawlab-hidden-facet", "1");
      host.setAttribute("hidden", "hidden");
    }

    function hideCategoryVendorFacets() {
      var selectors = [
        'accordion-custom[data-filter-param-name="filter.p.vendor"]',
        'accordion-custom[data-filter-param-name="filter-p-vendor"]',
        'accordion-custom[data-filter-param-name*="vendor"]',
        'accordion-custom[data-filter-param-name*="product-type"]',
        'accordion-custom[data-filter-param-name*="product_type"]',
        'details[id*="filter-p-vendor"]',
        'details[id*="filter-p-product-type"]',
        'details[id*="filter-p-product_type"]',
        '#facet-inputs-filter-p-vendor',
        '#facet-inputs-component-filter-p-vendor'
      ];
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var host = el.closest("accordion-custom") || el.closest(".facets__item") || el.closest("details") || el;
          hideHost(host);
          if (host !== el) hideHost(el.closest("details") || el);
        });
      });
      document.querySelectorAll(".facets__label, .facets summary, legend, #filters-drawer .facets__label").forEach(function (lab) {
        var t = (lab.textContent || "").replace(/\s+/g, " ").trim();
        if (t === "產品類別" || t === "Product type" || t === "產品類型" || t === "Vendor" || t === "品牌" || t === "供應商") {
          var host = lab.closest("accordion-custom") || lab.closest(".facets__item") || lab.closest("details") || lab.closest("fieldset");
          hideHost(host);
        }
      });
    }

    function resultsRoots() {
      var roots = [];
      document.querySelectorAll("#ResultsList, results-list, .product-grid-container, .collection-wrapper .product-grid, ul.product-grid").forEach(function (el) {
        if (el.closest("related-products, product-recommendations, .related-products")) return;
        roots.push(el);
      });
      if (!roots.length) {
        var grid = document.querySelector(".product-grid, results-list");
        if (grid) roots.push(grid);
      }
      return roots;
    }

    function cardRoot(el) { return el.closest("li, .product-grid__item, product-card") || el; }

    function hydrateCard(card) {
      if (!card) return;
      var pid = card.getAttribute("data-product-id") || "";
      var meta = PRODUCT_META[pid];
      if (!meta) return;
      if (!card.getAttribute("data-pawlab-use-case")) card.setAttribute("data-pawlab-use-case", meta.use);
      if (!card.getAttribute("data-pawlab-colors")) card.setAttribute("data-pawlab-colors", meta.colors);
    }

    function collectCards() {
      var cards = [], seen = {};
      resultsRoots().forEach(function (root) {
        root.querySelectorAll("product-card[data-product-id], .product-card[data-product-id]").forEach(function (c) {
          var pid = c.getAttribute("data-product-id") || "";
          if (pid && seen[pid]) return;
          if (pid) seen[pid] = 1;
          hydrateCard(c);
          cards.push(c);
        });
      });
      if (!cards.length) {
        document.querySelectorAll("product-card[data-product-id], .product-card[data-product-id]").forEach(function (c) {
          hydrateCard(c);
          cards.push(c);
        });
      }
      return cards;
    }

    function uniqueSorted(arr) {
      var seen = {}, out = [];
      arr.forEach(function (v) {
        var k = String(v || "").trim();
        if (!k || seen[k]) return;
        seen[k] = 1;
        out.push(k);
      });
      out.sort(function (a, b) { return a.localeCompare(b, isEn ? "en" : "zh-Hant"); });
      return out;
    }

    function colorsFromCards(cards) {
      var all = [];
      cards.forEach(function (c) {
        (c.getAttribute("data-pawlab-colors") || "").split(",").forEach(function (p) { if (p.trim()) all.push(p.trim()); });
      });
      return uniqueSorted(all);
    }

    function useCasesFromCards(cards) {
      var all = [];
      cards.forEach(function (c) {
        (c.getAttribute("data-pawlab-use-case") || "").split(",").forEach(function (p) { if (p.trim()) all.push(p.trim()); });
      });
      return uniqueSorted(all);
    }

    function useCaseLabel(v) {
      var k = String(v || "").toLowerCase();
      if (k === "interior" || k === "室內") return LABELS.interior;
      if (k === "exterior" || k === "戶外" || k === "outdoor" || k.indexOf("外出") !== -1) return LABELS.exterior;
      return v;
    }

    function selectedValues(root, name) {
      return Array.prototype.slice.call(root.querySelectorAll('input[name="' + name + '"]:checked')).map(function (i) { return i.value; });
    }

    function applyFilters(panel) {
      if (!panel) return;
      var colors = selectedValues(panel, "pawlab-filter-color");
      var uses = selectedValues(panel, "pawlab-filter-use");
      var cards = collectCards();
      var visible = 0;
      cards.forEach(function (card) {
        hydrateCard(card);
        var cCols = (card.getAttribute("data-pawlab-colors") || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
        var cUse = (card.getAttribute("data-pawlab-use-case") || "").split(",").map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        var okColor = !colors.length || colors.some(function (c) { return cCols.indexOf(c) !== -1; });
        var okUse = !uses.length || uses.some(function (u) {
          var want = String(u).toLowerCase();
          return cUse.some(function (x) {
            if (want === "interior") return x === "interior" || x === "室內";
            if (want === "exterior") return x === "exterior" || x === "戶外" || x === "outdoor" || x.indexOf("外出") !== -1;
            return x === want;
          });
        });
        var show = okColor && okUse;
        var host = cardRoot(card);
        if (host) host.style.display = show ? "" : "none";
        if (show) visible += 1;
      });
      document.querySelectorAll(".products-count-wrapper span, .products-count").forEach(function (el) {
        var t = (el.textContent || "").trim();
        if (!t) return;
        if (isEn) {
          if (/\d+\s*items?/i.test(t) || /\d+\s*products?/i.test(t)) el.textContent = visible + (visible === 1 ? " item" : " items");
        } else if (/\d+\s*個品項/.test(t) || /\d+\s*件商品/.test(t)) {
          el.textContent = visible + " 個品項";
        }
      });
    }

    function buildGroup(title, name, values, labelFn) {
      if (!values.length) return null;
      var details = document.createElement("details");
      details.className = "facets__panel pawlab-facet";
      details.setAttribute("open", "open");
      details.setAttribute("data-pawlab-facet", name);
      var summary = document.createElement("summary");
      summary.className = "facets__summary";
      var lab = document.createElement("span");
      lab.className = "facets__label";
      lab.textContent = title;
      summary.appendChild(lab);
      details.appendChild(summary);
      var wrap = document.createElement("div");
      wrap.className = "facets__inputs facets__panel-content";
      var ul = document.createElement("ul");
      ul.className = "facets__inputs-list list-unstyled";
      values.forEach(function (v, i) {
        var li = document.createElement("li");
        li.className = "facets__inputs-list-item";
        var box = document.createElement("div");
        box.className = "checkbox";
        var input = document.createElement("input");
        input.type = "checkbox";
        input.className = "checkbox__input";
        input.name = name;
        input.value = v;
        input.id = "pawlab-" + name + "-" + i;
        var label = document.createElement("label");
        label.className = "checkbox__label";
        label.setAttribute("for", input.id);
        label.textContent = labelFn ? labelFn(v) : v;
        box.appendChild(input);
        box.appendChild(label);
        li.appendChild(box);
        ul.appendChild(li);
      });
      wrap.appendChild(ul);
      details.appendChild(wrap);
      var item = document.createElement("div");
      item.className = "facets__item pawlab-facet-item";
      item.setAttribute("data-pawlab-facet", name);
      item.appendChild(details);
      return item;
    }

    function facetAnchor(kind) {
      if (kind === "vendor") {
        return document.querySelector('.facets-block-wrapper accordion-custom[data-filter-param-name*="vendor"], #filters-drawer accordion-custom[data-filter-param-name*="vendor"], accordion-custom[data-filter-param-name="filter-p-vendor"]')
          || document.querySelector('.facets-block-wrapper details[id*="filter-p-vendor"], #filters-drawer details[id*="filter-p-vendor"], details[id*="filter-p-vendor"]');
      }
      return document.querySelector('.facets-block-wrapper accordion-custom[data-filter-param-name*="price"], #filters-drawer accordion-custom[data-filter-param-name*="price"]')
        || document.querySelector('.facets-block-wrapper details[id*="filter-v-price"], details[id*="filter-v-price"], details[id*="price"]');
    }

    function findFacetMount() {
      var vendor = facetAnchor("vendor");
      if (vendor) {
        var vHost = vendor.closest("accordion-custom") || vendor.closest(".facets__item") || vendor;
        if (vHost.parentNode) return { parent: vHost.parentNode, before: vHost };
      }
      var price = facetAnchor("price");
      if (price) {
        var pHost = price.closest("accordion-custom") || price.closest(".facets__item") || price;
        if (pHost.parentNode) return { parent: pHost.parentNode, before: pHost };
      }
      var list = document.querySelector(".facets__filters-wrapper, .facets__filters, .facets-vertical, .facets form, facet-form")
        || document.querySelector(".facets-block-wrapper--vertical .facets")
        || document.querySelector("#filters-drawer .facets, #filters-drawer facet-form");
      if (list) return { parent: list, before: list.firstChild };
      return null;
    }

    function mountFilters() {
      hideCategoryVendorFacets();
      if (document.querySelector("[data-pawlab-plp-filters='1']")) {
        hideCategoryVendorFacets();
        return;
      }
      var cards = collectCards();
      if (!cards.length) return;
      var mount = findFacetMount();
      if (!mount) return;

      var panel = document.createElement("div");
      panel.className = "pawlab-plp-extra-filters";
      panel.setAttribute("data-pawlab-plp-filters", "1");

      var colorGroup = buildGroup(LABELS.color, "pawlab-filter-color", colorsFromCards(cards), colorLabel);
      var useVals = useCasesFromCards(cards);
      if (!useVals.length) useVals = ["interior", "exterior"];
      var useGroup = buildGroup(LABELS.useCase, "pawlab-filter-use", useVals, useCaseLabel);
      if (colorGroup) panel.appendChild(colorGroup);
      if (useGroup) panel.appendChild(useGroup);
      if (!panel.children.length) return;

      if (mount.before) mount.parent.insertBefore(panel, mount.before);
      else mount.parent.appendChild(panel);

      try {
        var drawerFacets = document.querySelector("#filters-drawer .facets__filters-wrapper, #filters-drawer .facets__filters, #filters-drawer facet-form, #filters-drawer .facets");
        if (drawerFacets && !drawerFacets.querySelector("[data-pawlab-plp-filters='drawer']")) {
          var clone = panel.cloneNode(true);
          clone.setAttribute("data-pawlab-plp-filters", "drawer");
          var drawerVendor = drawerFacets.querySelector('accordion-custom[data-filter-param-name*="vendor"]') || drawerFacets.querySelector('details[id*="filter-p-vendor"]');
          var dHost = drawerVendor ? (drawerVendor.closest("accordion-custom") || drawerVendor.closest(".facets__item") || drawerVendor) : null;
          if (dHost && dHost.parentNode === drawerFacets) drawerFacets.insertBefore(clone, dHost);
          else drawerFacets.insertBefore(clone, drawerFacets.firstChild);
          clone.addEventListener("change", function () { syncPanels(clone, panel); applyFilters(panel); });
        }
      } catch (e) {}

      panel.addEventListener("change", function () { applyFilters(panel); });
      hideCategoryVendorFacets();
    }

    function syncPanels(from, to) {
      if (!from || !to) return;
      ["pawlab-filter-color", "pawlab-filter-use"].forEach(function (name) {
        var fromVals = selectedValues(from, name);
        to.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
          input.checked = fromVals.indexOf(input.value) !== -1;
        });
      });
    }

    function run() {
      hideCategoryVendorFacets();
      mountFilters();
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
    else run();
    setTimeout(run, 50);
    setTimeout(run, 400);
    setTimeout(run, 1200);
    setTimeout(run, 2500);
    document.addEventListener("shopify:section:load", run);
    document.addEventListener("facet:update", run);
    document.addEventListener("facets:updated", run);

    try {
      var obs = new MutationObserver(function () {
        hideCategoryVendorFacets();
        if (!document.querySelector("[data-pawlab-plp-filters='1']")) mountFilters();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 20000);
    } catch (e) {}
  } catch (e) {}
})();

}

;/* pawlab-shop-category-morph-20260729 */
(function(){
  try{
    function css(){
      if(document.getElementById('pawlab-shop-category-style-runtime')) return;
      var el=document.createElement('style');
      el.id='pawlab-shop-category-style-runtime';
      el.textContent='[id*="__collection_list_shopCategory"] .section-background,[id*="__collection_list_shopCategory"] .section,[id*="__collection_list_JFpDxe"] .section-background,[id*="__collection_list_JFpDxe"] .section{background-color:#f3efe9!important}[id*="__collection_list_shopCategory"] .section,[id*="__collection_list_JFpDxe"] .section{--color-background:#f3efe9!important;--gap:8px!important}[id*="__collection_list_shopCategory"] .text-block,[id*="__collection_list_JFpDxe"] .text-block{--padding-block-end:4px!important;padding-block-end:4px!important}';
      (document.head||document.documentElement).appendChild(el);
    }
    function morph(){
      css();
      var stale=document.querySelector('[id*="__collection_list_JFpDxe"]');
      var freshAlready=document.querySelector('[id*="__collection_list_shopCategory"]');
      if(freshAlready){css();return;}
      if(!stale) return;
      var path=(location.pathname||'/');
      var base=path.indexOf('/en')===0?'/en':'';
      var key='template--22504894300397__collection_list_shopCategory';
      fetch(base+'/?sections='+encodeURIComponent(key),{credentials:'same-origin'})
        .then(function(r){return r.json();})
        .then(function(data){
          var html=data&&data[key];
          if(!html) return;
          var wrap=document.createElement('div');
          wrap.innerHTML=html;
          var fresh=wrap.firstElementChild;
          if(fresh&&stale.parentNode) stale.parentNode.replaceChild(fresh,stale);
          css();
        }).catch(function(){css();});
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',morph);
    else morph();
  }catch(e){}
})();

